module.exports = __webpack_public_path__ + "app/principal/companies-details-Eyo7RvmV.html";